const configPush = {
    push: {
        listLayout: 'PushListDefaultLayout',
        filterLayout: 'PushFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getPush',
        listApiParamSet: {
            ip:1,
            sp:10,
        },
        keyName: 'as_idx',
        deleteApiParamsSet : {},
        deleteSuccessType : 1,
        deleteFailTypes : {},
        deleteFunc : 'deletePush'
    },
    detail:{
        writeLayouts: ['PushWriteDefaultLayout'],
        getFunc: 'getPush',
        detailApiParamsSet: {
            ip:0,
            sp:10,
        },
        writeFunc: 'updatePush',
        writeApiParamSet: {
        },
        parsingData: {
            status: 'or_status',
            content: 'or_reply',
        },
        directType: 'back',
        // keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {},
        keyName: 'as_idx',
        deleteApiParamsSet : {},
        deleteSuccessType : 1,
        deleteFailTypes : {},
        deleteFunc : 'deletePush',
        directUrl : 'board/push',
    },
    pushCreate:{
        writeLayouts: ['PushWriteDefaultLayout'],
        // getFunc: 'getPush',
        detailApiParamsSet: {
            ip:0,
            sp:10,
        },
        writeFunc: 'createPush',
        writeApiParamSet: {
            as_code : 'push'
        },
        parsingData: {
            type: 'as_type',
            title : 'as_title',
            content: 'as_content',
            reservation : 'as_reservation',

            //선택
            reservationDate : 'as_reservation_date',
            residenceCountry : 'mp_residence_country',
            spoken : 'asp_spoken',
            study : 'ast_study',
            time :'t_idx',
            country : 'c_idx',
            gender : 'as_gender',
        },
        directUrl: '/board/push/',
        directType: 'detail',
        keyName: 'as_idx',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeOptionalParams : [
            'asp_spoken','ast_study','t_idx','c_idx','as_gender','mp_residence_country'
        ]
    },
    pushDetail:{
        writeLayouts: ['PushDetailDefaultLayout'],
        getFunc: 'getPush',
        detailApiParamsSet: {
            ip:0,
            sp:10,
        },
        writeFunc: 'updatePush',
        writeApiParamSet: {
        },
        parsingData: {
        },
        directUrl: '/board/push/',
        directType: 'back',
        keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {},
        deleteFunc : 'deletePush',
        deleteSuccessType : 1,
        deleteFailTypes : {},
        deleteApiParamsSet : {},
        writeKey : 'as_idx'
    },
    pushScheduler: {
        listLayout: 'PushListSchedulerLayout',
        filterLayout: 'PushFilterSchedulerLayout',
        paginationLayout: 'PaginationSchedulerLayout',
        getFunc: 'getPushScheduler',
        listApiParamSet: {
            ip:1,
            sp:10,
        },
        keyName: 'id',
        deleteApiParamsSet : {},
        deleteSuccessType : 1,
        deleteFailTypes : {},
        deleteFunc : ''
    },
    pushSchedulerDetail:{
        writeLayouts: ['PushWriteSchedulerLayout'],
        getFunc: 'getPushScheduler',
        detailApiParamsSet: {
            ip:0,
            sp:10,
        },
        writeFunc: 'updatePushScheduler',
        writeApiParamSet: {
            ast_idx : '',
            ast_title: '',
            ast_message: '',
        },
        parsingData: {
            titleScheduler : 'ast_title',
            contentScheduler: 'ast_message',
        },
        directUrl: '/board/scheduler/',
        directType: 'back',
        keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeOptionalParams : [
        ]
    },
}

export default {
    methods: {
        returnPushConfig(type) {
            return configPush[type];
        }
    },
    filterConfig: {
        // 날짜
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        pgnu: {
            type: 'query',
            classname: 'searchInput',
        },

        pg:{
            type:'match',
            classname:'filterPayType'
        },
        cid: {
            type: 'match',
            classname: 'langOption'
        },

        //여기서 쓰는 것

        //검색, 제목 내용
        ti: {
            type: 'query',
            classname: 'searchInput',
        },
        content: {
            type: 'query',
            classname: 'searchInput',
        },

        //발송 상태
        st:{
            type:'match',
            classname:'filterStatus'
        },

        //발송 구분
        ty:{
            type:'match',
            classname:'filterStatus'
        },

        // 알림 코드
        co:{
            type:'query',
            classname:'searchInput'
        },
    }

}
